import {
  superadmin,
  companyLogin,
  staffLogin,
  companySignup,
  adminForgot,
  staffForgot,
  companyAdminForgot,
  resetPassword,
  companyResetPassword,
  staffResetPassword,
  companySetpassword,
  staffSetpassword,
  userSetpassword,
  userLogin,
  userForgot,
  userResetPassword,
  logoutUpdate,
  autoLogin,
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import Cookies from 'js-cookie'

const auth = {
  state: {
    currentUser: (Cookies.get('currentUser')) ? JSON.parse(Cookies.get('currentUser')) : {},
    whitelabel: (Cookies.get('whitelabel')) ? JSON.parse(Cookies.get('whitelabel')) : { logo: "", background_image: ""},
    token: getToken(),
    name: '',
    avatar: '',
    roles: (Cookies.get('roles')) ? Cookies.get('roles') : {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      Cookies.set('roles', roles)
    },
    SET_USER: (state, user) => {
      state.currentUser = user
      Cookies.set('currentUser', user)
    },
    SET_CONFIRMATION_VOTE: (state, confirmation_vote) => {
      state.confirmation_vote = confirmation_vote
    },
    SET_WHITELABEL: (state, whitelabel) => {
      state.whitelabel = whitelabel;
      Cookies.set('whitelabel', whitelabel)
    },
    SET_USER_ACTIVE_CHANNEL: (state, login = true) => {
      // Added Token for privatisation
      window.Echo.connector.options.auth = {
        headers: {
          Authorization: login && state.token ? "Bearer " + state.token : null
        }
      };
    },
  },

  actions: {
    /**
     * Login API
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    SuperadminLogin({
      commit
    }, userInfo) {
      const email = userInfo.email.trim()
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        superadmin(email, password).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if (data.data) {
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * company login
     **/
    CompanyLogin({
      commit
    }, userInfo) {
      const email = userInfo.email.trim()
      const password = userInfo.password
      const slug = userInfo.slug
      return new Promise((resolve, reject) => {
        companyLogin(email, password, slug).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if (data.data) {
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * department login
     **/
    DepartmentLogin({
      commit
    }, userInfo) {
      const email = userInfo.email.trim()
      const password = userInfo.password
      const slug = userInfo.slug
      return new Promise((resolve, reject) => {
        companyLogin(email, password, slug).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if (data.data) {
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * staff login
     **/
    StaffLogin({
      commit
    }, staffInfo) {
      const email = staffInfo.email.trim()
      const password = staffInfo.password
      const slug = staffInfo.slug
      return new Promise((resolve, reject) => {
        staffLogin(email, password, slug).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if (data.data) {
            data.data.company_slug = slug
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * Logout
     * @param commit
     * @param state
     * @returns {Promise<any>}
     * @constructor
     */
    /**
     * logout
     **/
    Logout({
      commit
    }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        Cookies.remove('roles')
        Cookies.remove('currentUser')
        removeToken()
        resolve()
      })
    },
    /**
     * LeaveStaff
     **/
    LeaveStaff({
      commit
    }, data) {
      return new Promise((resolve) => {

        logoutUpdate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })

      });

    },
    /**
     * company logout
     **/
    CompanyLogout({
      commit
    }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        Cookies.remove('roles')
        Cookies.remove('currentUser')
        removeToken()
        resolve()
      })
    },

    /**
     * company sign up
     * @param {*} param0
     * @param {*} data
     */
    CompanySignup({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        companySignup(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //User forgot password
    UserForgot({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        userForgot(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //forgot password
    AdminForgot({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        adminForgot(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    CompanyAdminForgot({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        companyAdminForgot(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    StaffForgot({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        staffForgot(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //reset password
    UserResetPassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        userResetPassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //reset password
    ResetPassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        resetPassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //reset password
    CompanyResetPassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        companyResetPassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    StaffResetPassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        staffResetPassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * company set password
     * @param {*} param0
     * @param {*} data
     */
    CompanySetpassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        companySetpassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * staff set password
     * @param {*} param0
     * @param {*} data
     */
    StaffSetpassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        staffSetpassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * user set password
     * @param {*} param0
     * @param {*} data
     */
    UserSetpassword({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        userSetpassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Login API
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    UserLogin({
      commit
    }, userInfo) {
      const email = userInfo.email.trim()
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        userLogin(email, password).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if (data.data) {
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    AutoLogin({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        autoLogin(data).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if (data.data) {
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          commit('SET_LOCALE', data.data.language)
          commit('SET_USER_ACTIVE_CHANNEL', true)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default auth
